import { AppData, Registry } from '@lightningjs/sdk';
// @ts-ignore
import processEnv from 'processEnv';
import { AnnouncerIntegration } from 'config/platforms/AbstractAnnouncerIntegration';
import { createTizenAnnouncerIntegration } from 'config/platforms/tizen/TizenAnnouncerIntegration';
import { createVizioAnnouncerIntegration } from 'config/platforms/vizio/VizioAnnouncerIntegration';
import { createLGAnnouncerIntegration } from 'config/platforms/lg/LGAnnouncerIntegration';
import { createComcastAnnouncerIntegration } from 'config/platforms/comcast/ComcastAnnouncerIntegration';
import { createUnknownAnnouncerIntegration } from 'config/platforms/unknown/UnknownAnnouncerIntegration';
import { translate } from 'support/translate';

let AnnouncerIntegrationClass: AnnouncerIntegration;
switch (processEnv.APP_PLATFORM) {
  case 'tizen':
    AnnouncerIntegrationClass = createTizenAnnouncerIntegration();
    break;
  case 'vizio':
    AnnouncerIntegrationClass = createVizioAnnouncerIntegration();
    break;
  case 'lg':
    AnnouncerIntegrationClass = createLGAnnouncerIntegration();
    break;
  case 'comcast':
    AnnouncerIntegrationClass = createComcastAnnouncerIntegration();
    break;
  case 'unknown':
  default:
    AnnouncerIntegrationClass = createUnknownAnnouncerIntegration();
    break;
}

export default class Announcer extends AnnouncerIntegrationClass {
  override announcerEnabled = AppData!.device.getAnnouncerEnabled();
  private _tempAnnouncerValue = this.announcerEnabled;
  private onSpeakEvent: ((isSpeaking: boolean) => void) | null = null;
  private isSpeaking = false;

  private _announceLoadingTimer: number | null = null;

  protected initializeAnnouncer() {
    this.announcerEnabled = AppData!.device.getAnnouncerEnabled();
    this.stage.on<any>('announceEnded', this.onVoiceOutDone.bind(this));

    this.setupAnnouncerChange();
  }

  protected announcerHandleLoadingStart() {
    this.$announcerCancel();

    this._announceLoadingTimer = Registry.setTimeout(() => {
      this._announceLoadingTimer = null;
      this.$announce(translate('ttsPrompts.loading'));
      this._tempAnnouncerValue = this.announcerEnabled;
      this.announcerEnabled = false;
    }, 200);
  }

  protected announcerHandleLoadingEnd() {
    if (this._announceLoadingTimer) {
      Registry.clearTimeout(this._announceLoadingTimer);
      this._announceLoadingTimer = null;
    }
    this.announcerEnabled = this._tempAnnouncerValue;
  }

  getIsEnabled = () => {
    return this.announcerEnabled;
  };

  getIsSpeaking = () => {
    return this.announcerEnabled && this.isSpeaking;
  };

  setOnSpeakEvent = (fn: (isSpeaking: boolean) => void) => {
    this.onSpeakEvent = fn;
  };

  removeOnSpeakEvent = () => {
    this.onSpeakEvent = null;
  };

  override _setup() {
    AppData!.announcerService = {
      getIsSpeaking: this.getIsSpeaking,
      setOnSpeakEvent: this.setOnSpeakEvent,
      removeOnSpeakEvent: this.removeOnSpeakEvent,
      getIsEnabled: this.getIsEnabled,
    };
  }

  override onVoiceOutStart() {
    if (this.isSpeaking) return;

    this.isSpeaking = true;
    this.onSpeakEvent?.(true);
  }

  override onVoiceOutDone() {
    if (!this.isSpeaking) return;

    this.isSpeaking = false;
    this.onSpeakEvent?.(false);
  }

  private setupAnnouncerChange(): void {
    AppData?.device.handleAnnouncerChange((announcerEnabled: boolean) => {
      this.announcerEnabled = announcerEnabled;
      this._tempAnnouncerValue = announcerEnabled;
    });
  }
}
